import { makeStyles } from '@material-ui/core';
import logo from '../../assets/logo.svg';

const useStyles = makeStyles({
  img: {
    display: 'block',
    height: 34,
    width: 'auto',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img src={logo} alt="Pub Invest" className={classes.img} />;
};
